import React from 'react';
import {
  StructureLeftRightWrapper,
  LevelOneInfoStyled,
  LevelOneInfoVolume
} from '../../../../MyTeamBackofficeStyled';

import { useSelector } from 'react-redux';
import { DotLineArrows } from '../../../common';
import { RootTeamMemberInfo } from '../../../../common';
import { getIsLegsWeaker, getLegStregthsS } from '../../../../utils';
import { BV, TV, formatVP } from '../../../../../../helpers/helperFunctions';
import { useTranslation } from 'react-i18next';
import { CaptionText } from '../../../../../../styles/FontStyles';
import { color } from '../../../../../../styles/GlobalStyles';

export const ZeroLevelInfo = ({ isOpen }) => {
  const { t } = useTranslation('myTeam');
  let { rootTeamMemberInfoTrading, rootTeamMemberTrading } = useSelector(
    (store) => store.myTeamBackoffice
  );

  const [leftLegStrenght, rightLegStrength] = getLegStregthsS(
    rootTeamMemberTrading
  );
  const [isLeftLegWeaker, isRightLegWeaker] = getIsLegsWeaker(
    rootTeamMemberTrading
  );

  return (
    <LevelOneInfoStyled open={isOpen}>
      <DotLineArrows />
      <StructureLeftRightWrapper>
        <div>
          <h1>{t('left_team')}</h1>
          {leftLegStrenght}
          <LevelOneInfoVolume weaker={isLeftLegWeaker}>
            <div>
              <h1>Volume Points</h1>

              <h2>
                {formatVP(
                  rootTeamMemberInfoTrading?.leftLegInfo?.legTotalVolume
                )}{' '}
                {TV}
              </h2>

              {rootTeamMemberTrading?.todayLeftLegTotalVolume >= 0 && (
                <h1>
                  <span
                    style={{
                      color: color.colors.primary900
                    }}>
                    +{formatVP(rootTeamMemberTrading?.todayLeftLegTotalVolume)}{' '}
                  </span>
                  {t('today')}
                </h1>
              )}
            </div>
          </LevelOneInfoVolume>
        </div>
        <div>
          <h1>{t('right_team')}</h1>
          {rightLegStrength}
          <LevelOneInfoVolume weaker={isRightLegWeaker}>
            <div>
              <h1>Volume Points</h1>
              <h2>
                {formatVP(
                  rootTeamMemberInfoTrading?.rightLegInfo?.legTotalVolume
                )}{' '}
                {TV}
              </h2>
              {rootTeamMemberTrading?.todayRightLegTotalVolume >= 0 && (
                <h1>
                  <span
                    style={{
                      color: color.colors.primary900
                    }}>
                    +{formatVP(rootTeamMemberTrading?.todayRightLegTotalVolume)}{' '}
                  </span>
                  {t('today')}
                </h1>
              )}
            </div>
          </LevelOneInfoVolume>
        </div>
      </StructureLeftRightWrapper>
    </LevelOneInfoStyled>
  );
};
